import React from 'react';
import { Box, Container, Grid, Typography } from '@material-ui/core';
import { AppDetailsItemHeader } from './AppDetailsItemHeader';
import { IAppDetailsView } from '../AppDetailsView';

export const AppDetailsKeyBenefits = ({ listing }: IAppDetailsView) => {
    if (listing.keyBenefits?.length <= 0) {
        return null;
    }

    return (
        <Box>
            <Container>
                <Box p={4}>
                    <AppDetailsItemHeader header={'Key benefits'} />

                    <Grid container spacing={4}>
                        {Array.from(listing.keyBenefits).map((ben, i) => (
                            <Grid key={i} item xs={12} sm={6} md={4} spacing={2}>
                                {listing.includeKeyBenefitsImages && ben.image && (
                                    <Box
                                        my={2}
                                        style={{
                                            width: '100%',
                                            height: '150px',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <img
                                            style={{
                                                height: 'auto',
                                                width: '100%',
                                                borderRadius: '5px',
                                            }}
                                            alt={'app-logo'}
                                            src={ben.image.sourceUrl}
                                        />
                                    </Box>
                                )}
                                <Box my={2}>
                                    <Box py={2} fontWeight={'Bold'} fontSize={16}>
                                        {ben.title}
                                    </Box>
                                    <Box py={1}>
                                        <Typography variant={'body1'}>{ben.description}</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};
